enum BeneficiaryType {
  Primary = 1,
  Contingent = 2,
  Tertiary = 3,
}

export default BeneficiaryType;
